import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// material
import { Box, Grid, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
import { MedicalInsuranceAdminTable } from "../components/_dashboard/app";
import { getMedicalInsurancePostdocAdmin } from "../core/service/medicalInsurancePostdoc.service";
// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function MedicalInsurance() {
  const navigate = useNavigate();
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [listMedicalInsurancePostdoc, setListMedicalInsurancePostdoc] =
    useState([{}]);
  const { entities } = listMedicalInsurancePostdoc;

  const medicalInsurancePostdocAdmin = async (id) => {
    const data = await getMedicalInsurancePostdocAdmin(id);
    setListMedicalInsurancePostdoc(data);
  };

  useEffect(() => {
    if (currentUser.role != ROLE_ADMIN) {
      navigate("/404", { replace: true });
    }
    medicalInsurancePostdocAdmin();
  }, []);

  return (
    <Page title="Medical Insurance">
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={12}>
            <MedicalInsuranceAdminTable listMedical={entities || []} />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
